import {createContext, useContext} from 'react';

export const UserContext = createContext({user:{},setUser:() => {}});

export default function useUserContext() {
    return useContext(UserContext);
};
